import Header from './Header';

export { Header };



// WEBPACK FOOTER //
// ./src/components/PagePage/components/index.js